import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const OTHER = "__other__";

// Wiederverwendbare Hersteller-Auswahl: Dropdown aus der Stammdatenliste "hersteller"
// + Option "Sonstiger Hersteller" für Freitext. Wert bleibt ein einfacher String (Label).
export function ManufacturerSelect({ value, onChange, testid = "manufacturer-select" }) {
  const [options, setOptions] = useState([]);
  const [other, setOther] = useState(false);

  useEffect(() => {
    api.get("/v1/catalogs/component-option-lists")
      .then((r) => { const l = (r.data || []).find((x) => x.key === "hersteller"); setOptions(l?.items || []); })
      .catch(() => setOptions([]));
  }, []);

  const labels = options.map((o) => o.label);
  useEffect(() => { setOther(!!value && !labels.includes(value)); }, [value, options]); // eslint-disable-line react-hooks/exhaustive-deps

  const selectValue = other ? OTHER : (labels.includes(value) ? value : "");

  return (
    <>
      <Select value={selectValue} onValueChange={(v) => {
        if (v === OTHER) { setOther(true); onChange(""); }
        else { setOther(false); onChange(v); }
      }}>
        <SelectTrigger data-testid={testid}><SelectValue placeholder="Hersteller wählen …" /></SelectTrigger>
        <SelectContent>
          {options.map((o) => <SelectItem key={o.key} value={o.label}>{o.label}</SelectItem>)}
          <SelectItem value={OTHER}>Sonstiger Hersteller …</SelectItem>
        </SelectContent>
      </Select>
      {other && (
        <Input className="mt-1.5" placeholder="Hersteller eingeben" data-testid={`${testid}-other`}
          value={value || ""} onChange={(e) => onChange(e.target.value)} />
      )}
    </>
  );
}
